import { useCallback, useRef, useState } from 'react';

const TOAST_DURATION = 2500;

export function useToast(): [string | null, (msg: string) => void] {
  const [message, setMessage] = useState<string | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  const show = useCallback((msg: string) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setMessage(msg);
    timerRef.current = setTimeout(() => {
      setMessage(null);
      timerRef.current = undefined;
    }, TOAST_DURATION);
  }, []);

  return [message, show];
}
